export default __webpack_public_path__ + "static/media/ginger-image-cropped.6aa5b14e.svg";